import { ChartBar, ChartBarStacked, ChartColumn, Donut } from "lucide-react";
import {
  TARS_BAR_CHART,
  TARS_COLUMN_CHART,
  TARS_DONUT_CHART,
  TARS_STACKED_BAR_CHART,
} from "./facet-chart-types";

export function FacetChartTypeToolbarIcon({
  chartTypeId,
  className,
}: {
  chartTypeId: string;
  className?: string;
}) {
  /** Match JSON / Table segment icons: Lucide size 15, stroke 2. */
  const cn = className ?? "shrink-0";
  const iconProps = { size: 15 as const, strokeWidth: 2 as const, className: cn };
  switch (chartTypeId) {
    case TARS_BAR_CHART:
      return <ChartBar {...iconProps} aria-hidden />;
    case TARS_STACKED_BAR_CHART:
      return <ChartBarStacked {...iconProps} aria-hidden />;
    case TARS_DONUT_CHART:
      return <Donut {...iconProps} aria-hidden />;
    case TARS_COLUMN_CHART:
    default:
      return <ChartColumn {...iconProps} aria-hidden />;
  }
}
